<template>
  <div class="Index">
    <!-- <NavBar/> -->
    <Cooperation />
    <Driver/>
    <Huozhu />
    <CompanyProfile />
    <!-- <Honor/> -->
    <ProductsService />
    <NavBarTwo />
    <FooterNew />
    <!-- <EnteringEnterprise/> -->
    <!-- <FourBlock/>
    <Production/>
    <Strength/>
    <Partner/>
    <Download/>
    <AboutUs/> -->
    <!-- <div class="SideCodeBlcok">
      <img src="../../static/img/qrcode1.png" />
      <p>APP下载</p>
      <img src="../../static/img/gray.png" />
      <p>小程序</p>
    </div> -->
  </div>
</template>

<script>
import FooterNew from '../components/FooterNew.vue'
import NavBar from '../components/NavBar.vue'
import Cooperation from '../components/Cooperation'
import Driver from '../components/driver.vue'
import Huozhu from '../components/huozhu.vue'
import CompanyProfile from '../components/CompanyProfile.vue'
import ProductsService from '../components/products&services.vue'
// import EnteringEnterprise from '../components/EnteringEnterprise.vue'
import NavBarTwo from '../components/NavBarTwo.vue'
export default {
  name: 'Index',
  components: {
    NavBar,
    Cooperation,
    Driver,
    Huozhu,
    CompanyProfile,
    ProductsService,
    FooterNew,
    // EnteringEnterprise,
    NavBarTwo
    // Strength,
    // Partner,
    // Download,
    // AboutUs
  },
  watch: {
    '$route.query.mao': function () {
      console.log('selector111:', this.$route.query.mao)
      let mao = this.$route.query.mao
      if (mao) {
            let selector = '#' + mao
            this.jump(selector)
      }
    }
  },
  mounted () {
    let mao = this.$route.query.mao
      if (mao) {
            let selector = '#' + mao
            this.jump(selector)
      }
  },
  methods: {
    jump (selector) {
      console.log('selector:', selector)
      let jump = document.querySelectorAll(selector)
        // 获取需要滚动的距离
        let total = jump[0].offsetTop
        // Chrome
        document.body.scrollTop = total
        // Firefox
        document.documentElement.scrollTop = total
        // Safari
        window.pageYOffset = total
    }
  }
}
</script>

<style>
.SideCodeBlcok{
  width: 80px;
  height: 220px;
  background:rgba(255, 255, 255, 0.7);
  position: fixed;
  top: 150px;
  right: 10px;
  z-index: 19;
  text-align: center;
}
.SideCodeBlcok img{
  width:60px;
  height: 60px;
  display: block;
  margin:20px 10px 0 10px;
}
.SideCodeBlcok p{
  width: 100%;
  height:20px;
  line-height: 20px;
}
@media (max-width: 640px){
  .SideCodeBlcok{
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Index.vue